import { GridArrowData } from "./UIState";
import * as React from "react";

export function Arrow(props: { data: GridArrowData }) {
    return <div className={`arrow ${props.data.direction}`}>➡</div>;
}
